import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from '../../../context/UserContext';
import { isAdmin, isModerator } from '../../utils/roles';
import HrnbLoader from '../../../components/controls/HrnbLoader';

/**
 * Компонент-обёртка для защиты роутов админ-панели
 * @param {React.ReactNode} children - Защищаемый контент
 * @param {string} requiredAccess - 'admin' или 'moderator'
 */
const AdminAuthGuard = ({ children, requiredAccess = 'admin' }) => {
    const { currentUser, loading } = useContext(UserContext);

    // Показываем загрузчик пока данные пользователя загружаются
    if (loading) {
        return <HrnbLoader />;
    }

    // Не авторизован
    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    // Проверка прав
    if (requiredAccess === 'admin') {
        if (!isAdmin(currentUser)) {
            return <Navigate to="/" replace />;
        }
    } else if (requiredAccess === 'moderator') {
        if (!isModerator(currentUser)) {
            return <Navigate to="/" replace />;
        }
    }

    return children;
};

export default AdminAuthGuard;
